import React, {useEffect, useRef, useState} from 'react';
import cx from 'classnames';
import {motion} from 'framer-motion';
import {useWindowSize} from 'react-use';
import {Switch} from '@headlessui/react';
import {useIsVisible} from 'react-is-visible';

const Timeline = () => {
  return (
    <g className="timeline">
      <g className="loading-1">
        <g strokeLinecap="round">
          <path
            d="m592.004 297.093 203.23.73 1.08 150.75-209.13-3.38"
            strokeWidth={0}
            fill="#e7f5ff"
          />
          <path
            d="M592.914 296.113c47.88 1.97 98.51.3 204.61 4.05m-207.45-1.6c67.37-5.25 136.26-4.42 205.33-.91m4.09-.13c-2.24 38.02-.84 78.84-.82 148.45m-3.41-147.11c-1.17 31.9.4 63.79-.69 148.13m4.78-4.13c-58.79.14-108.41-1.16-208.51-.25m204.23 1.74c-43.15-4.43-88.75-1.34-205.25 1.5m1.46-2.08c-4.33-47.72 1.85-97.53 1.42-146m-.01 146.75c-1.04-47.03-2.54-95.32-2.91-146.89"
            stroke="#1864ab"
            fill="none"
          />
        </g>
        <g strokeLinecap="round">
          <path
            d="M629.266 377.734c2.73-5.77 6.55-26.29 16.46-34.29 9.9-7.99 29.96-15.55 42.95-13.66 12.98 1.9 30.83 12.53 34.95 25.05 4.12 12.52-1.67 40.34-10.23 50.08-8.56 9.74-30.09 8.7-41.13 8.35-11.03-.36-20.66-8.85-25.07-10.49m-19.06-22.7c2.53-5.55 6.7-26.9 16.72-35.12 10.01-8.21 30.16-15.47 43.36-14.17 13.2 1.29 31.87 9.5 35.85 21.94 3.98 12.43-3.03 42.22-11.94 52.69-8.92 10.47-30.89 10.28-41.55 10.13-10.66-.14-18.66-8.88-22.42-11"
            stroke="#1864ab"
            fill="none"
          />
          <path
            d="m628.976 377.124-.86-14.41 13.52 2.55-12.36 13.73"
            strokeWidth={0}
            fill="#1864ab"
            fillRule="evenodd"
          />
          <path
            d="M628.606 377.924c.18-4.79-.96-10.42.49-14.68m.54 13.84c-1.37-4.36-1.41-9.28-1.6-14.55m-.04.26c3.45 1.79 7.77 3.47 12.19 3.44m-11.77-3.43c2.17 1.53 4.35 1.37 12.1 4.12m-1.55-.85c-1.82 3.81-4.59 5.53-10.77 10.39m11.4-9.41c-2.64 1.48-3.52 3.84-10.04 10.91m-.29-.23s0 0 0 0m0 0s0 0 0 0"
            stroke="#1864ab"
            fill="none"
          />
        </g>
      </g>
      <path
        d="M 982.629 330.641 h 13.7 m -13.7 0 h 13.7"
        stroke="#1864ab"
        strokeWidth={4}
        fill="none"
        strokeLinecap="round"
      />
      <g className="server hidden md:block">
        <g fillRule="evenodd" strokeLinecap="round">
          <path
            d="m2939.281 939.627 2.67 270.44-2.44 29.85-1.08-.82 5.46 9.07 19.76 5.93 38.25 8.72 40.3 4.87 44.91-.57 44.02-3.01 33.79-.66 26.86-9.98 21.08-6.21 1.37-12.62 1.09 4.64-1.09-304.33-.84 2.31-8.09-8.78-10.74-4.56-23-6.94-55.34-2.18-43.91-3.31-34.11.83-31.2 2.35-32.61 4.56-22.76 10.08-6.7 2.34-5.76 8.74.87-1.22"
            strokeWidth={0}
            fill="#e7f5ff"
          />
          <path
            d="M2939.111 940.277c.23 44.97 1.83 218.47 2.08 268.12.25 49.66-2.78 22.29-.59 29.83 2.19 7.54 3.11 11.33 13.74 15.41 10.62 4.08 27.71 6.6 50 9.05 22.3 2.44 56.7 5.94 83.78 5.62 27.09-.32 58.65-4.33 78.73-7.54 20.08-3.22 33.69-7.63 41.73-11.76 8.05-4.13 5.45-7 6.56-13 1.12-6 .14 22.62.14-22.98 0-45.61.19-204.87-.13-250.67-.33-45.81 1.36-18.01-1.82-24.17s-8.07-9.34-17.27-12.79c-9.19-3.45-17.64-5.51-37.9-7.89-20.26-2.39-58.23-6.12-83.66-6.44-25.42-.32-48.3 1.67-68.87 4.53-20.56 2.85-43.36 8.82-54.51 12.59-11.15 3.76-10.44 8.21-12.37 10-1.93 1.79.69.56.77.72m1.36.94c.11 45.21-.35 220.15-.46 270.01-.12 49.86-2.63 22.19-.26 29.16 2.38 6.97 3.99 8.75 14.51 12.67s26.66 8.17 48.62 10.86c21.96 2.7 55.78 5.29 83.16 5.31 27.37.01 60.32-2.09 81.07-5.22 20.74-3.14 35.73-9.44 43.39-13.58 7.65-4.15 1.76-5.29 2.55-11.31.8-6.02 1.89 21.47 2.21-24.81.32-46.29-.24-207.07-.3-252.92-.06-45.85 3.12-16.32-.06-22.17-3.19-5.86-9.35-9.58-19.04-12.97-9.7-3.39-18.98-5.01-39.14-7.38-20.17-2.36-56.79-6.16-81.85-6.79-25.06-.63-48.16-.06-68.51 3.03-20.34 3.09-42.55 11.44-53.58 15.51-11.03 4.07-10.68 7.27-12.61 8.91-1.94 1.63 1.2 1.03.99.89"
            stroke="#1864ab"
            fill="none"
          />
        </g>
        <path
          d="M2945.488 1144.402c1.28 2.28-.11 8.79 5.98 12.51 6.09 3.72 18.14 7.04 30.56 9.81 12.42 2.77 26.08 5.55 43.96 6.83 17.88 1.28 39.68 1.55 63.32.86 23.65-.69 58.35-1.65 78.55-4.99 20.2-3.34 33.72-10.57 42.67-15.03 8.95-4.47 9.48-9.68 11.03-11.75m-276.91.89c1.15 2-.84 7.48 5.79 11.58s21.84 10.3 33.96 13.02c12.13 2.71 21.03 2.68 38.79 3.28 17.76.6 43.95.8 67.78.3 23.84-.5 55.27-.75 75.23-3.31 19.96-2.55 35.41-7.66 44.53-12.01 9.12-4.35 8.43-12.01 10.19-14.1M2940.71 1038.67c1.45 1.68 1.14 7.41 7.56 11.38 6.43 3.97 18.74 9.67 30.97 12.42 12.23 2.74 24.39 2.92 42.42 4.05 18.03 1.12 42.26 3.23 65.78 2.69 23.53-.54 55.49-2.8 75.39-5.92 19.89-3.13 34.98-8.33 43.99-12.81 9-4.49 8.47-12.03 10.03-14.09m-277.43 1.16c1.43 2.3 1.71 9.65 8.23 13.51 6.53 3.87 18.47 7.01 30.91 9.68 12.45 2.67 25.76 5.39 43.76 6.35 18 .97 40.56-.29 64.22-.56 23.66-.27 57.62 1.77 77.73-1.07 20.1-2.83 34.29-11.56 42.88-15.94 8.59-4.38 6.9-8.28 8.66-10.35"
          stroke="#1864ab"
          fill="none"
          strokeLinecap="round"
        />
        <g strokeLinecap="round">
          <path
            d="M3030.494 913.502c14.99-1.62 35.78-1.78 53.32-1.66 17.54.11 35.99.95 51.92 2.36 15.94 1.42 31.93 3.41 43.7 6.14 11.77 2.73 21.3 6.7 26.95 10.25 5.65 3.55 8.03 7.61 6.95 11.04-1.08 3.42-5.99 6.51-13.42 9.52-7.43 3.02-18.2 6.18-31.15 8.56-12.95 2.37-30.01 4.37-46.55 5.72-16.55 1.35-35.13 2.56-52.72 2.37-17.59-.19-37.13-1.87-52.82-3.51-15.69-1.64-29.62-3.6-41.32-6.34-11.7-2.75-22.87-6.87-28.89-10.12-6.03-3.25-8.42-6.09-7.25-9.4 1.17-3.31 6.55-7.01 14.26-10.47 7.72-3.47 17.77-7.91 32.04-10.32 14.26-2.41 43.38-3.43 53.54-4.14 10.15-.71 6.8-.44 7.39-.11m-9.24-.28c14.98-1.33 35.63-2.04 53.49-1.72 17.85.32 38.24 2.05 53.62 3.62 15.38 1.57 28.08 3.05 38.68 5.79 10.6 2.74 19.95 7.1 24.92 10.65 4.96 3.56 6.66 7.15 4.88 10.68-1.78 3.53-7.28 7.51-15.56 10.51-8.27 3.01-20.4 5.4-34.08 7.53-13.69 2.13-31.16 4.4-48.02 5.26-16.85.86-35.68.46-53.11-.1-17.44-.57-36.06-1.65-51.51-3.3-15.45-1.64-30.39-3.92-41.2-6.58-10.8-2.65-18.88-6.18-23.63-9.35-4.75-3.18-6.6-6.09-4.88-9.71 1.73-3.62 6.69-8.77 15.23-12.01s22.34-5.29 36.01-7.43c13.68-2.14 37.98-4.9 46.02-5.41 8.05-.52 1.54 1.61 2.26 2.3"
            strokeWidth={0}
            fill="#fff"
          />
          <path
            d="M3021.884 913.012c14.48-1.76 35.1-.53 52.5-.59 17.4-.06 35.79-1 51.87.23 16.09 1.22 32.01 4.7 44.66 7.12 12.65 2.42 24.2 4.17 31.26 7.4 7.05 3.23 10.69 8.22 11.07 11.99.38 3.77-2.49 7.4-8.79 10.62-6.29 3.23-16.91 6.18-28.98 8.74-12.06 2.55-27.4 5.13-43.42 6.59-16.03 1.46-35.35 2.11-52.72 2.16-17.38.06-35.32-.67-51.53-1.85-16.21-1.18-32.86-2.83-45.72-5.24-12.87-2.41-24.23-5.74-31.48-9.23-7.24-3.5-11.62-8.06-11.99-11.71-.38-3.66 3.37-7.01 9.74-10.21 6.37-3.19 14.16-6.31 28.46-8.97 14.31-2.65 45.26-5.87 57.34-6.98 12.09-1.12 14.41-.09 15.16.31m2.33-1.1c15.66-1.26 34.69-1.99 51.59-1.48 16.89.52 34.97 2.35 49.79 4.56 14.82 2.2 29.43 5.35 39.15 8.66 9.73 3.31 16.22 7.97 19.2 11.21 2.98 3.23 1.97 5.02-1.33 8.18-3.29 3.16-8.55 7.67-18.44 10.77-9.88 3.11-26.22 5.97-40.87 7.85-14.64 1.89-29.86 2.84-47.01 3.48-17.15.64-38.6 1.1-55.88.37-17.27-.74-33.48-2.69-47.79-4.77-14.32-2.08-28.18-4.68-38.08-7.7-9.9-3.02-17.82-6.91-21.35-10.41-3.52-3.49-3.45-7.27.18-10.54 3.64-3.28 11.79-6.11 21.62-9.09 9.83-2.98 22.46-6.71 37.39-8.78 14.93-2.06 43.52-3.37 52.2-3.64 8.69-.27-.43 1.21-.09 2.03"
            stroke="#1864ab"
            fill="none"
          />
        </g>
        <g strokeLinecap="round">
          <path
            d="M3180.18 988.239c3.99-1.19 8.36.24 12.06 2.45 3.7 2.2 8.46 6.49 10.17 10.78 1.7 4.28 1.62 10.53.08 14.92-1.53 4.4-5.5 9.03-9.32 11.47-3.82 2.45-9.4 3.76-13.6 3.22-4.19-.55-8.72-2.97-11.58-6.49-2.86-3.52-5.65-9.89-5.57-14.65.08-4.76 2.69-10.36 6.05-13.89 3.36-3.52 11.28-6.21 14.11-7.27 2.84-1.05 2.91.68 2.88.94m-9.19.59c3.79-1.88 10.13-1.56 14.26-.02 4.13 1.53 8.17 5.34 10.5 9.25 2.32 3.91 4.15 9.46 3.45 14.21-.7 4.75-4.02 11-7.64 14.3-3.63 3.29-9.53 5.67-14.1 5.46-4.56-.2-10.15-3.37-13.28-6.68-3.12-3.31-4.84-8.58-5.47-13.18-.64-4.59-.44-10.62 1.67-14.4 2.12-3.78 9.39-6.76 11.02-8.28 1.62-1.53-1.53-1.02-1.26-.86"
            strokeWidth={0}
            fill="#fff"
          />
          <path
            d="M3184.05 989.389c4.1-.06 11.21 2.21 14.33 5.23 3.12 3.02 3.98 8.25 4.37 12.9.39 4.64.41 11.1-2.03 14.96-2.44 3.86-8.46 6.91-12.61 8.17-4.15 1.25-8.59 1.25-12.3-.63-3.7-1.88-7.96-6.48-9.92-10.66-1.96-4.19-2.86-9.91-1.82-14.46 1.04-4.55 4.37-10.24 8.08-12.84 3.71-2.59 11.64-2.3 14.18-2.75 2.54-.44 1.01-.06 1.07.09m.53-.55c4.1 1 8.47 4.79 10.99 8.7 2.51 3.91 4.13 9.91 4.09 14.76-.05 4.86-1.43 11.08-4.37 14.36-2.94 3.28-8.76 4.97-13.29 5.33-4.52.35-10.28-.69-13.83-3.19-3.55-2.51-6.46-7.08-7.48-11.86-1.01-4.78-.17-12.34 1.41-16.84 1.58-4.51 4.39-8.51 8.08-10.19 3.68-1.68 11.55.17 14.03.1 2.48-.07.58-.56.85-.53"
            stroke="#1864ab"
            fill="none"
          />
        </g>
        <g strokeLinecap="round">
          <path
            d="M3173.95 1085.735c3.54-2.3 9.79-1.82 13.96-.59 4.18 1.24 8.58 4.41 11.06 8 2.48 3.59 4.16 9.03 3.83 13.54-.33 4.52-2.81 10.09-5.81 13.53-2.99 3.44-8.01 6.6-12.16 7.11-4.16.51-9.16-1.66-12.77-4.06-3.61-2.4-7.61-6.05-8.89-10.32-1.28-4.27-1.13-10.8 1.21-15.3 2.34-4.51 10.21-9.69 12.85-11.76 2.63-2.07 2.98-.84 2.98-.69m3.21-.9c3.95-.33 9.63 1.6 12.92 4.68 3.29 3.09 6.1 9.2 6.83 13.86.73 4.66-.58 10.29-2.46 14.11-1.88 3.83-5.13 7.35-8.81 8.84-3.68 1.49-9.01 1.4-13.27.1-4.26-1.31-9.73-4.03-12.28-7.92-2.55-3.89-3.64-10.74-3.02-15.43.62-4.7 3.3-9.48 6.76-12.77 3.45-3.28 11.86-6.26 13.98-6.95 2.12-.69-1.08 2.44-1.25 2.82"
            strokeWidth={0}
            fill="#fff"
          />
          <path
            d="M3193.71 1087.685c3.64 1.84 6.99 5.13 8.39 9.41 1.4 4.27 1.33 11.8.01 16.23s-4.27 7.86-7.93 10.35c-3.66 2.49-9.74 5-14.03 4.6-4.3-.4-8.87-3.46-11.74-6.99-2.87-3.54-5.34-9.54-5.49-14.22-.15-4.68 1.96-10.19 4.58-13.86s6.53-7.33 11.16-8.16c4.64-.83 13.73 2.27 16.66 3.18 2.93.91 1.29 1.94.9 2.27m-21.49-5.11c3.76-2.12 9.7-2.38 13.96-.88 4.27 1.51 8.98 6 11.64 9.91 2.65 3.91 4.74 9.13 4.29 13.55-.45 4.43-3.81 9.7-6.96 13.01-3.16 3.3-7.8 6.26-11.96 6.81-4.16.54-9.19-.66-12.99-3.55-3.8-2.9-8.47-9.08-9.82-13.8-1.36-4.72-.47-10.51 1.7-14.53s9.55-8.25 11.3-9.58c1.76-1.34-.6 1.49-.78 1.57"
            stroke="#1864ab"
            fill="none"
          />
        </g>
        <g strokeLinecap="round">
          <path
            d="M3180.25 1188.194c3.94-.83 10.69.5 14.42 2.99 3.73 2.48 6.89 7.49 7.96 11.92 1.08 4.44.32 10.37-1.51 14.67-1.84 4.29-5.74 8.85-9.51 11.1-3.77 2.26-8.93 3.5-13.13 2.42-4.19-1.08-9.63-5.09-12.02-8.91-2.39-3.81-2.74-9.53-2.29-13.99.44-4.45 1.94-9.56 4.96-12.75 3.02-3.2 10.89-5.21 13.16-6.41 2.27-1.19.64-.96.47-.74m9.15 2.37c3.91 1.51 7.77 6 9.81 10.07 2.04 4.07 3.44 9.68 2.43 14.35-1.01 4.68-4.68 10.68-8.5 13.7-3.82 3.02-9.85 4.96-14.4 4.41-4.55-.55-9.98-4.14-12.89-7.7-2.91-3.57-4.25-9.05-4.57-13.7-.31-4.64.29-10.57 2.68-14.16 2.38-3.59 7.64-6.16 11.63-7.4 4-1.24 9.9-.13 12.33-.03 2.42.09 2.33.43 2.21.59"
            strokeWidth={0}
            fill="#fff"
          />
          <path
            d="M3190.88 1189.594c3.98.94 6.9 4.83 9.07 8.83 2.18 3.99 4.67 10.52 3.99 15.13-.69 4.6-4.86 9.43-8.11 12.49-3.25 3.05-7.32 5.71-11.4 5.83-4.07.12-9.63-2.18-13.06-5.1-3.43-2.91-6.68-7.78-7.53-12.38-.84-4.6.38-11.25 2.48-15.22 2.11-3.98 5.41-7.45 10.17-8.62 4.76-1.16 14.61.82 18.36 1.62 3.76.81 4.31 3.1 4.15 3.23m-22.76-5.92c3.81-1.55 9.86-1.09 14.15.82 4.29 1.92 9.47 6.64 11.59 10.69 2.12 4.06 2.21 9.17 1.11 13.65-1.11 4.49-4.36 10.2-7.74 13.23-3.38 3.04-8.37 5.4-12.53 4.98-4.16-.41-9.02-4.11-12.44-7.47-3.41-3.36-7.24-8.38-8.07-12.67-.82-4.29.65-9.19 3.13-13.07 2.48-3.88 9.57-8.41 11.75-10.2 2.17-1.79 1.44-1.13 1.3-.55"
            stroke="#1864ab"
            fill="none"
          />
        </g>
      </g>
      <g className="client hidden md:block">
        <path
          d="M175.197 893.913c9.147-4.987 20.304-5.554 31.446-5.406 11.15.16 25.118 2.144 35.418 6.305 10.308 4.174 18.606 10.207 26.404 18.71 7.806 8.517 16.445 21.174 20.395 32.367 3.937 11.2 4.253 23.429 3.286 34.82-.967 11.392-4.762 22.796-9.078 33.532-4.316 10.737-8.538 22.605-16.813 30.869-8.276 8.273-22.36 14.726-32.84 18.741-10.489 4.013-18.994 6.017-30.076 5.349-11.07-.676-26.065-4.71-36.387-9.39-10.332-4.683-17.85-10.317-25.553-18.706-7.7-8.398-16.735-20.81-20.665-31.649-3.943-10.832-3.775-21.929-2.956-33.345.828-11.414 3.416-24.54 7.915-35.141 4.5-10.601 9.384-19.91 19.104-28.47 9.724-8.569 31.245-19.425 39.223-22.899 7.981-3.483 8.405.346 8.658 2.018m88.909 42.706c6.08 8.86 9.244 23.916 10.011 35.798.767 11.882-1.712 24.284-5.39 35.5-3.67 11.217-9.7 22.516-16.657 31.819-6.958 9.303-15.178 18.822-25.096 23.986-9.92 5.174-22.786 6.408-34.403 7.011-11.62.613-24.62-.065-35.305-3.382-10.684-3.317-20.79-8.522-28.812-16.514-8.02-8.001-14.067-20.582-19.29-31.47-5.224-10.886-10.79-22.892-12.047-33.872-1.256-10.98.509-21.27 4.522-31.985 4-10.708 11.271-23.04 19.532-32.293 8.26-9.253 20.538-18.33 30.035-23.234 9.507-4.902 16.34-4.998 26.98-6.16s25.893-4.423 36.877-.81c10.977 3.603 20.71 14.884 29.003 22.467 8.305 7.575 17.548 18.494 20.773 22.993 3.227 4.49.009 2.971-1.432 3.988"
          stroke="#1864ab"
          strokeWidth={2}
          fill="none"
          strokeLinecap="round"
        />
        <path
          d="M120.352 945.453c1.109-3.704 11.162-15.422 8.8-18.741-2.362-3.32-14.736-4.827-22.972-1.177-8.228 3.661-22.096 15.087-26.41 23.112-4.315 8.024-1.922 18.194.535 25.039 2.446 6.843 8.644 11.805 14.162 16.033 5.527 4.23 14.48 16.118 18.97 9.316 4.49-6.812 6.932-41.527 7.971-50.127m1.641 2.585c.758-3.52 7.054-18.435 4.01-22.264-3.043-3.83-14.563-3.162-22.257-.72-7.685 2.443-19.297 7.824-23.858 15.37-4.573 7.553-6.01 21.33-3.517 29.9 2.49 8.579 13.267 18 18.46 21.555 5.186 3.543 8.853 7.56 12.682-.28 3.84-7.84 7.773-38.463 10.303-46.764M294.467 984.409c.108-2.77-.35-17.096 4.313-19.49 4.672-2.393 17.793-1.132 23.685 5.125 5.9 6.27 11.694 23.372 11.703 32.456-.002 9.082-5.596 16.26-11.661 22.034-6.055 5.776-18.42 11.207-24.69 12.617-6.27 1.41-13.035 5.139-12.946-4.138.091-9.286 11.604-43.734 13.495-51.549m.664 2.283c-.345-3.461-5.754-21.327-2.218-23.257 3.527-1.934 16.69 5.47 23.397 11.673 6.707 6.203 17.06 16.9 16.847 25.531-.214 8.631-12.017 19.752-18.152 26.259-6.123 6.5-13.405 11.73-18.633 12.769-5.237 1.037-11.899 1.667-12.73-6.542-.84-8.211 6.816-34.918 7.723-42.697"
          stroke="#1864ab"
          strokeWidth={2}
          fill="none"
          strokeLinecap="round"
        />
        <path
          d="M118.06 922.414c3.307-8.025 5.584-36.41 16.43-49.358 10.847-12.948 31.244-23.566 48.648-28.323 17.396-4.77 38.463-3.661 55.758-.277s35.6 10.633 47.99 20.578c12.38 9.952 21.896 27.213 26.32 39.093 4.423 11.89 1.022 22.319.224 32.21-.8 9.9-4.942 22.208-5.02 27.162m-194.205-36.363c3.18-7.398 7.1-36.175 18.372-50.708 11.283-14.541 31.458-31.632 49.292-36.514 17.824-4.885 39.472 2.874 57.713 7.21 18.232 4.335 39.98 9.795 51.713 18.824 11.725 9.018 14.653 23.936 18.65 35.326 3.993 11.398 4.75 22.58 5.328 33.04.565 10.469-1.206 24.928-1.902 29.757M95.15 992.726c.784 2.866 1.036 10.435 4.473 16.433 3.435 6.007 9.517 15.124 16.142 19.581 6.622 4.467 15.983 6.291 23.585 7.208 7.593.915 17.768-1.025 21.996-1.704m-61.513-41.771c.52 3.07-5.736 13.977-3.013 19.21 2.732 5.236 12.315 7.822 19.39 12.2 7.084 4.38 14.67 13.173 23.095 14.047 8.436.867 23.938-7.204 27.484-8.825"
          stroke="#1864ab"
          strokeWidth={2}
          fill="none"
          strokeLinecap="round"
        />
        <path
          d="M173.29 1024.556c2.548.128 5.758 3.555 8.865 4.975 3.12 1.412 7.921 2.225 9.797 3.509 1.875 1.284 2.546 2.407 1.469 4.188-1.067 1.783-5.147 6.062-7.891 6.504-2.745.443-5.486-3.14-8.57-3.877-3.083-.736-7.41 1.1-9.935-.521-2.533-1.634-4.59-7.338-5.237-9.257-.648-1.92-2.444-1.665 1.358-2.28 3.81-.602 17.018-2.464 21.477-1.373 4.459 1.09 5.54 7.407 5.26 7.937m-16.03-10.104c2.956.316 6.364 3.995 9.312 5.48 2.957 1.488 6.38 2.222 8.405 3.439 2.013 1.224 4.163 2.87 3.704 3.903-.46 1.042-3.084 1.842-6.473 2.318-3.382.487-10.133 1.189-13.847.602-3.724-.59-6.246-2.663-8.445-4.146-2.2-1.474-4.364-3.586-4.772-4.73-.411-1.134.206-1.225 2.294-2.11 2.098-.883 8.871-2.421 10.282-3.178 1.402-.76-1.734-1.446-1.85-1.35M151.683 957.885c2.413-2.135 7.821-8.135 11.65-10.857 3.829-2.722 7.69-6.875 11.345-5.472 3.66 1.394 8.172 8.97 10.611 13.88 2.43 4.907 3.092 13.201 4.02 15.571m-39.048-17.395c2.863-3.066 10.662-9.061 14.245-10.887 3.579-1.817 3.483-1.446 7.253-.024 3.775 1.414 12.952 3.971 15.378 8.54 2.422 4.58-.4 15.493-.839 18.891M61.047 1124.748c98.51-1.34 197.87 3.09 267.94-1.83m-268.75 1.42c91.91-.22 189.43-1.57 266.77-1.81m-1.29 3.08c1.72 58.28.62 115.13 2.22 161.45m.79-163.41c2.1 38.85 1.36 78.44-1.9 160.75m.25 1.5c-73.29 1.57-151.18-.78-269.55.34m269.4-2.43c-79.69 1.23-158.25 2.22-268.26 2.58m-1.58-4.94c3.69-30.79 2.11-74.72.23-157.06m-.3 158.79c-.09-36.56.96-72.3-.17-161.8M195.036 1188.516c2.79-.06 4.91 1.09 6.69 2.64 1.78 1.54 2.83 3.82 3.99 6.61 1.17 2.79 4.17 7.27 3.01 10.14-1.15 2.87-7.34 6.04-9.92 7.1-2.57 1.06-2.79.42-5.53-.73-2.73-1.14-9.07-3.81-10.88-6.13-1.8-2.32-.06-4.91.08-7.8.13-2.89-3.15-8.16.73-9.54 3.88-1.38 18.33-.83 22.52 1.27 4.2 2.1 2.94 11.15 2.62 11.33m-5.4-13.04c2.82 1.42 4.06 5.75 4.51 8.5.46 2.75-.39 6.04-1.79 8-1.41 1.97-4.3 2.6-6.63 3.77-2.34 1.18-4.69 3.36-7.39 3.28-2.69-.08-6.88-1.86-8.78-3.77-1.9-1.91-3.1-5.22-2.63-7.7.47-2.48 3.55-4.79 5.46-7.17 1.91-2.37 3.66-6.28 5.99-7.07 2.34-.8 6.53 1.8 8.02 2.32 1.49.53.75 1.17.94.81M256.702 986.682c-.333-3.598-2.826-15.189-4.368-19.29-1.54-4.112-.735-4.917-4.889-5.37-4.144-.453-14.916.035-20.016 2.654-5.11 2.628-9.696 10.634-10.635 13.095m37.276 6.163c-.728-3.496-3.632-9.599-4.756-14.093-1.124-4.503 1.573-11.201-1.975-12.929-3.547-1.727-14.843-1.153-19.29 2.536-4.446 3.698-5.733 16.574-7.409 19.633"
          stroke="#1864ab"
          strokeWidth={2}
          fill="none"
          strokeLinecap="round"
        />
        <path
          d="M326.7 1286.822c5.58.7 30.68 3.98 35.88 6.74 5.21 2.75 2.77 8.47-4.63 9.77-7.41 1.3-20.97-2.96-39.79-1.98-18.82.97-47.57 7.46-73.12 7.83-25.55.37-47.05-5.04-80.19-5.62-33.14-.57-93.25 5.18-118.66 2.18-25.42-3.01-31.54-16.61-33.83-20.22-2.29-3.61 16.51-.54 20.09-1.46m290.64 8.26c6.29-.13 39.27-4.62 44.85-2.3 5.58 2.32-3.31 14.12-11.38 16.23-8.06 2.11-17.9-3.01-37.03-3.56-19.13-.55-51.24-.72-77.74.24-26.5.96-47.69 5.37-81.25 5.54-33.55.18-95.01-.35-120.1-4.49-25.09-4.14-29.76-16.63-30.44-20.34-.67-3.7 22.12-2.35 26.39-1.92M109.37 1106.058c-4.19.18-25.82 6.35-22.58 2.71 3.24-3.63 31.26-18.68 42-24.54 10.74-5.87 12.4-10.55 22.45-10.63 10.05-.08 24.07 8.06 37.84 10.15 13.77 2.08 30.89 5.51 44.77 2.37 13.88-3.13 30.51-19.76 38.51-21.19 7.99-1.42 4.8 5.81 9.45 12.65 4.65 6.83 21.75 22.85 18.45 28.37-3.3 5.53-26.52 4.09-38.25 4.76-11.73.68-26.75-.48-32.13-.73m-115.99 1.2c-4.42-.68-30.01-1.71-27.86-6.99 2.15-5.28 30.01-20.08 40.77-24.71 10.75-4.63 13.71-4.09 23.76-3.06 10.04 1.04 22.3 7.81 36.52 9.25 14.23 1.44 35.57 3.35 48.83-.63 13.26-3.98 22.24-21.72 30.74-23.22 8.51-1.51 15.21 7.39 20.31 14.2 5.09 6.81 14.36 21.2 10.29 26.65-4.08 5.45-23.77 4.5-34.72 6.07-10.96 1.56-25.13 3.52-31.02 3.32"
          stroke="#1864ab"
          strokeWidth={2}
          fill="none"
          strokeLinecap="round"
        />
      </g>
      <g strokeLinecap="round">
        <path
          d="M1079.687 302.78c92.72-31.26 305.03-203.74 556.55-189.24 251.53 14.51 793.8 230.13 952.61 276.28m-1510.46-87.81c93.04-31.02 308.41-202.11 560.08-187.3 251.67 14.8 791.37 229.99 949.94 276.13"
          stroke="#1864ab"
          fill="none"
        />
        <path
          d="M2559.297 389.95c8.29 2.27 18.93 2.53 29.23.19m-30.55.67c12.63.76 22.76.75 29.6.18"
          stroke="#1864ab"
          fill="none"
        />
        <path
          d="M2565.887 370.52c5.83 9 14.19 15.98 22.64 19.62m-23.96-18.76c10.25 8.02 17.92 15.29 23.01 19.61"
          stroke="#1864ab"
          fill="none"
        />
      </g>
      <path
        d="M2641.142 332.865v1439.69m0-1439.69v1439.69"
        stroke="#1864ab"
        fill="none"
        strokeLinecap="round"
      />
      <text
        y={35}
        fontFamily="Cascadia, Segoe UI Emoji"
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(2666.222 380.927)"
      >
        {'50ms'}
      </text>
      <path
        d="M2641.001 407.19h13.7m-13.7 0h13.7"
        stroke="#1864ab"
        fill="none"
        strokeLinecap="round"
      />
      <g strokeLinecap="round">
        <path d="m1560.816 10.11 300.72.1-1.17 169.89-302.49-1.78" strokeWidth={0} fill="#e7f5ff" />
        <path
          d="M1561.056 7.55c66.02.92 128.78-3.87 297.76 4.25m-298.84-2.03c89.92 2.23 179.31 2.8 301-.52m-.03 4.25c-.48 53.54-1.81 104-2.08 162.54m1.9-164.94c1 38.98-.49 78.44.22 165.61m-3.14-1.23c-106.33-.28-211.47-2.13-296.31-.69m297.39 1.6c-59.49-2.38-123.79-1.95-299.39-.69m-4.25-2.84c3.12-47.1 5.49-98.24-.01-159.66m4.77 165.12c-2.1-41.01-3.59-79.2.82-168.94"
          stroke="#1864ab"
          fill="none"
        />
      </g>
      <text
        y={35.5}
        fontFamily="Cascadia, Segoe UI Emoji"
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(1601.725 48.015)"
      >
        {'GET '}
      </text>
      <text
        y={79}
        fontFamily="Cascadia, Segoe UI Emoji"
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(1601.725 48.015)"
      >
        {'example.com'}
      </text>
      <path
        d="M997.786 328.569v1420.16m0-1420.16v1420.16"
        stroke="#1864ab"
        fill="none"
        strokeLinecap="round"
      />
      <text
        y={35}
        fontFamily="Cascadia, Segoe UI Emoji"
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(911.276 302.258)"
      >
        {'0ms'}
      </text>
    </g>
  );
};

const RenderedPage = () => {
  return (
    <g className="rendered-page">
      <g strokeLinecap="round">
        <path
          d="m596.778 1342.627 206.51 3.26-3.7 144.11-199.07.51"
          strokeWidth={0}
          fill="#e7f5ff"
        />
        <path
          d="M598.438 1342.307c59.69-.08 117.4 4.25 206.09.77m-208.08-1.75c80.55-1.02 159.75-.71 206.4 1.59m.63-1.97c3.64 53.77 4.41 107.03-3.05 145.71m3.08-144.25c-.2 36.55-3.72 77.56-.89 145.72m-1.84.58c-52.98-3.66-110.72-3.64-205.8-2.18m208.13 1.77c-43.01 1.44-84.12.72-204.56 2.47m-3.28-1.07c6-56.79 4.22-111.25 4-147.02m-.49 148.55c-3.96-43.98-4.49-90.55-.29-149.04"
          stroke="#1864ab"
          fill="none"
        />
      </g>
      <text
        y={35.5}
        fontFamily="Cascadia, Segoe UI Emoji"
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(632.014 1370.521)"
      >
        {'hello'}
      </text>
      <text
        y={79}
        fontFamily="Cascadia, Segoe UI Emoji"
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(632.014 1370.521)"
      >
        {'world!'}
      </text>
      <path
        d="M840.31 1487.85c2.29 4.06 6.43 24.86 16.96 22.89 10.53-1.98 38.41-29.37 46.23-34.75m-58.97 8.86c1.75 4.61.7 29.66 10.23 28.62 9.53-1.05 38.52-28.17 46.93-34.87"
        stroke="#1864ab"
        strokeWidth={4}
        fill="none"
        strokeOpacity={0.6}
        fillOpacity={0.6}
        strokeLinecap="round"
      />
    </g>
  );
};

const ServerResponseHTML = () => {
  return (
    <g className="server-response-html">
      <g strokeLinecap="round">
        <g transform="translate(10 10) rotate(0 6.851691502692347 0)">
          <path
            d="M 970.6 1395.157 h 13.7 m -13.7 0 h 14.4"
            stroke="#1864ab"
            strokeWidth="4"
            fill="none"
          ></path>
        </g>
      </g>
      <text
        y={35}
        fontFamily="Cascadia, Segoe UI Emoji"
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(838.152 1383.52)"
      >
        {'1500ms'}
      </text>
      <g strokeLinecap="round">
        <path
          d="M2596.121 1322.114c-259.75 12.75-1293.78 63.4-1553.46 75.77m1557.39-76.86c-260.14 13.07-1298.84 67.6-1558.21 80.56"
          stroke="#1864ab"
          fill="none"
        />
        <path
          d="M1073.091 1393.624c-14.27-2.38-27.37 7.53-31.29 4.54m28.73-9.15c-7.31 3.5-13.22 5.38-28.09 13.97"
          stroke="#1864ab"
          fill="none"
        />
        <path
          d="M1074.141 1414.114c-14.95-10.52-28.47-8.74-32.34-15.95m29.78 11.35c-7.8-1.43-13.95-4.48-29.14-6.53"
          stroke="#1864ab"
          fill="none"
        />
      </g>
      <g strokeLinecap="round">
        <path
          d="m1494.84 1051.26 907.1-.51-2.21 283.55-902.55 3.25"
          strokeWidth={0}
          fill="#e7f5ff"
        />
        <path
          d="M1498.24 1051.07c269.96 3.88 539.34 4.51 903.5-.57m-904.28 1.52c297.62-2.53 595.55-3.44 903.21-.84m1.05 1.81c1.53 66.32-.75 133.37.34 281.07m-2.36-283.4c1.23 102.06 2.2 201.59 2.5 282.45m-2.71.63c-183.35-3.58-371.96-3.12-901.74-.75m902.43.37c-266.47-5.72-532.63-6.1-903.63 1.41m2.16 1.75c-2.9-69.16-5.17-134.03 1.24-286.14m-2.55 283.79c1.07-97.24.39-192.51-.63-281.39"
          stroke="#1864ab"
          fill="none"
        />
      </g>
      <text
        y={34.6}
        fontFamily="Cascadia, Segoe UI Emoji"
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(1530.86 1090.278)"
      >
        {'HTTP 200 OK'}
      </text>
      <text
        y={78.2}
        fontFamily="Cascadia, Segoe UI Emoji"
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(1530.86 1090.278)"
      >
        {'....'}
      </text>
      <text
        y={121.8}
        fontFamily="Cascadia, Segoe UI Emoji"
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(1530.86 1090.278)"
      >
        {'<link rel="preload" src="/index.css" />'}
      </text>
      <text
        y={165.4}
        fontFamily="Cascadia, Segoe UI Emoji"
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(1530.86 1090.278)"
      >
        {'...'}
      </text>
      <text
        y={209}
        fontFamily="Cascadia, Segoe UI Emoji"
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(1530.86 1090.278)"
      >
        {'<p>hello world!</p>'}
      </text>
    </g>
  );
};

const PreloadMetaRequests = () => {
  return (
    <g className="preload-meta-requests">
      <g strokeLinecap="round">
        <path
          d="M1025.915 1431.187c265.13 10.52 1325.06 52.08 1590.14 62.56m-1588.16-63.72c265.61 10.79 1325.91 54.33 1590.5 65.25"
          stroke="#1864ab"
          fill="none"
        />
        <path
          d="m2619.805 1493.327-14.32 9.59-1.7-13.15 15.07 6.04"
          strokeWidth={0}
          fill="#1864ab"
          fillRule="evenodd"
        />
        <path
          d="M2618.125 1494.387c-2.73 1.58-5.29 4.13-12.44 6.61m12.69-5.3c-4.02.81-8.96 2.78-14.28 5.81m-.4-1.65c2.18-3.17.02-6.81 2.41-12.28m-2.01 13.44c.16-3.36.12-6.3.48-12.92m1.69-.73c3.08 3.55 6.93 6.2 12.22 7.39m-13.65-6.06c3.34 1.41 6.45 2.79 14.18 6.34m-.62.24s0 0 0 0m0 0s0 0 0 0"
          stroke="#1864ab"
          fill="none"
        />
      </g>
      <g strokeLinecap="round">
        <path
          d="m1829.766 1382.758 308.75-4.45-.95 170.25-302.84-3.17"
          strokeWidth={0}
          fill="#e7f5ff"
        />
        <path
          d="M1831.936 1380.868c71.86 1.53 145.51 3.01 302.75.04m-300.21.27c77.02-1.41 156.41-1.07 301.19-.25m-4.63 3.63c4.86 42.17 5.51 98.57 1.19 160.09m2.47-165.2c-.7 43.69-.95 88.25-.8 167.81m-1.08 1.53c-59.36 3.69-120.22 2.55-300.16-3.15m302.75 2.03c-88.51-1.32-177.3-.18-302.2.54m-2.02-.64c4.66-61.13 2.46-121.02 2.34-163.27m.42 161.59c-1.66-33.1.97-64.91 1.05-163.6"
          stroke="#1864ab"
          fill="none"
        />
      </g>
      <text
        y={35.5}
        fontFamily="Cascadia, Segoe UI Emoji"
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(1876.255 1418.495)"
      >
        {'GET '}
      </text>
      <text
        y={79}
        fontFamily="Cascadia, Segoe UI Emoji"
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(1876.255 1418.495)"
      >
        {'/index.css'}
      </text>
      <g strokeLinecap="round">
        <path
          d="M2619.565 1527.183c-101.9 22.53-346.78 110.06-611.61 134.91-264.84 24.85-814.37 11.9-977.42 14.2m1587.56-150.37c-102.01 22.26-346.29 109.12-610.93 134.39-264.64 25.28-814.04 14.53-976.92 17.27"
          stroke="#1864ab"
          fill="none"
        />
        <path
          d="m1032.115 1676.303 13.11-4.6-.85 11.09-12.58-5.7"
          strokeWidth={0}
          fill="#1864ab"
          fillRule="evenodd"
        />
        <path
          d="M1029.755 1677.963c5.19-1.03 8.15-3.94 13.52-6.18m-13.59 5.18c4.25-1.74 9.07-3.16 14.13-5.11m-.49-1.77c.09 5.14-.41 6.12.08 14.17m-.1-13.63c-.09 3.01.25 6.28-.05 12.68m1.06 1.29c-4.41-2.93-11.27-6.46-14.16-5.71m13.93 5.07c-3.9-1.11-7.82-3.15-13.36-6.64m-.48.27s0 0 0 0m0 0s0 0 0 0"
          stroke="#1864ab"
          fill="none"
        />
      </g>
      <g strokeLinecap="round">
        <path
          d="m1230.339 1552.723 304.63-1.71-3.18 168.78-299.87-6.91"
          strokeWidth={0}
          fill="#e7f5ff"
        />
        <path
          d="M1233.649 1551.563c73.99-.27 144.31-1.27 301.45-1.68m-303.4-.57c107.33 4.83 215.25 3.9 303.54-.34m-4.85 0c9.97 32.76 3.74 68.27 4.73 164.86m-3.01-165.83c-2 50.26-.82 98.49 0 170.3m3.26.7c-71.13-1.93-143.28-1.12-299.93-3.2m298.67.94c-101.84.9-205.47 2.29-301.72 1.36m-.05-2.62c.79-38.59 4.04-81.95.61-163.01m-.86 165.51c5.11-52.28 5.14-107.89 1.76-166.17"
          stroke="#1864ab"
          fill="none"
        />
      </g>
      <text
        y={35.5}
        fontFamily="Cascadia, Segoe UI Emoji"
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(1275.018 1587.57)"
      >
        {'HTTP 200 OK '}
      </text>
      <text
        y={79}
        fontFamily="Cascadia, Segoe UI Emoji"
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(1275.018 1587.57)"
      >
        {'/index.css'}
      </text>
      <g strokeLinecap="round">
        <g transform="translate(10 10) rotate(0 6.851691502692347 0)">
          <path
            d="M 970.6 1650.157 h 13.7 m -13.7 0 h 14.4"
            stroke="#1864ab"
            strokeWidth="4"
            fill="none"
          ></path>
        </g>
      </g>
      <text
        y={35}
        fontFamily="Cascadia, Segoe UI Emoji"
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(831.733 1635.343)"
      >
        {'1800ms'}
      </text>
    </g>
  );
};

const EarlyHintResponse = () => {
  return (
    <g className="http-103">
      <g strokeLinecap="round">
        <path
          d="M2620.764 526.813c-193-13.35-891.2-102.26-1158.01-80.13-266.81 22.14-369.04 177.46-442.85 212.95m1600.86-132.82c-193-13.35-891.2-102.26-1158.01-80.13-266.81 22.14-369.04 177.46-442.85 212.95"
          stroke="#1864ab"
          fill="none"
        />
        <path
          d="m1019.904 659.633 7.17-13.18 7.53 10.2-14.7 2.98"
          strokeWidth={0}
          fill="#1864ab"
          fillRule="evenodd"
        />
        <path
          d="M1019.904 659.633c1.84-3.38 3.68-6.76 7.17-13.18m-7.17 13.18c2.51-4.62 5.02-9.23 7.17-13.18m0 0c2.23 3.03 4.46 6.05 7.53 10.2m-7.53-10.2c2.71 3.67 5.42 7.35 7.53 10.2m0 0c-3.47.7-6.93 1.41-14.7 2.98m14.7-2.98-14.7 2.98m0 0s0 0 0 0m0 0s0 0 0 0"
          stroke="#1864ab"
          fill="none"
        />
      </g>
      <g strokeLinecap="round">
        <path d="m1307.22 367.441 461.7 6.36.52 221.8-468.34 1.84" strokeWidth={0} fill="#e7f5ff" />
        <path
          d="M1302.86 371.831c147.53-2.07 291.85-1.03 465.05.37m-464.27-1.46c99.3 1.73 198.69 2.54 465.94.51m-.77 1.92c-.69 64.16-4.22 133.85-1.97 227.97m.9-231.47c2.59 70.09-.54 139.54 2.53 228.32m-2.7 1.01c-104.87-.31-210.2-.54-465.19-.73m467.24.2c-131.34-3.21-262.24-2.77-465.76.3m-1.12 1.75c1.41-53.17 1.49-106.98 3.91-230.32m-1.22 227.83c-4.13-75.8-4.34-154.02-1.56-226.81"
          stroke="#1864ab"
          fill="none"
        />
      </g>
      <text
        y={37.067}
        fontFamily="Cascadia, Segoe UI Emoji"
        fontSize={37.297}
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(1338.05 393.572)"
      >
        {'HTTP 103'}
      </text>
      <text
        y={82.135}
        fontFamily="Cascadia, Segoe UI Emoji"
        fontSize={37.297}
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(1338.05 393.572)"
      >
        {'....'}
      </text>
      <text
        y={127.202}
        fontFamily="Cascadia, Segoe UI Emoji"
        fontSize={37.297}
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(1338.05 393.572)"
      >
        {'Link: </index.css>;'}
      </text>
      <text
        y={172.27}
        fontFamily="Cascadia, Segoe UI Emoji"
        fontSize={37.297}
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(1338.05 393.572)"
      >
        {'...'}
      </text>
      <g strokeLinecap="round">
        <path
          d="M2612.09 847.953c-101.85 22.43-347.32 109.71-612.55 134.54-265.24 24.84-815.66 12.27-978.87 14.45"
          stroke="#1864ab"
          strokeWidth={1.5}
          fill="none"
          strokeDasharray="8 9"
          strokeOpacity={0.6}
          fillOpacity={0.6}
        />
        <g strokeOpacity={0.6} fillOpacity={0.6}>
          <path
            d="m1019.23 996.853 13.62-7.91-.53 12.43-13.2-5.32"
            strokeWidth={0}
            fill="#1864ab"
            fillRule="evenodd"
          />
          <path
            d="M1021.13 997.203c4.22-2.72 7.05-4.79 12.19-7.09m.54.85c1.03 4.22.28 6.85-.09 12.82m-.65-1.7c-3.6-1.53-6.09-2.47-12.5-3.91m.05-1.23s0 0 0 0"
            stroke="#1864ab"
            strokeWidth={1.5}
            fill="none"
          />
        </g>
      </g>
      <g strokeOpacity={0.6} fillOpacity={0.6} strokeLinecap="round">
        <path d="m1224.874 859.008 297.93-1-.5 167.5-299.02 2.37" strokeWidth={0} fill="#e7f5ff" />
        <path
          d="M1225.574 864.418c97.31-2.45 195.7-5.79 299.6-3.08m2.04 2.72c2.01 37.81-.98 76.59.44 164.46m-3.87-1.18c-106.33-.28-211.47-2.13-296.31-.69m-6.05.98c3.83-35.93-2.4-69.11 4.73-168.64"
          stroke="#1864ab"
          strokeWidth={1.5}
          fill="none"
          strokeDasharray="8 9"
        />
      </g>
      <g strokeOpacity={0.6} fillOpacity={0.6}>
        <text
          y={35.5}
          fontFamily="Cascadia, Segoe UI Emoji"
          fill="#1864ab"
          style={{
            whiteSpace: 'pre',
          }}
          transform="translate(1268.13 898.994)"
        >
          {'HTTP 200 OK '}
        </text>
        <text
          y={79}
          fontFamily="Cascadia, Segoe UI Emoji"
          fill="#1864ab"
          style={{
            whiteSpace: 'pre',
          }}
          transform="translate(1268.13 898.994)"
        >
          {'/index.css'}
        </text>
      </g>
      <g strokeLinecap="round">
        <path
          d="M1020.534 711.843c263.95 16.43 1319.73 82.17 1583.67 98.6"
          stroke="#1864ab"
          strokeWidth={1.5}
          fill="none"
          strokeDasharray="8 9"
          strokeOpacity={0.6}
          fillOpacity={0.6}
        />
        <g strokeOpacity={0.6} fillOpacity={0.6}>
          <path
            d="m2604.204 810.443-13.96 5.48.79-12.65 13.17 7.17"
            strokeWidth={0}
            fill="#1864ab"
            fillRule="evenodd"
          />
          <path
            d="M2604.204 810.443c-4.62 1.81-9.24 3.63-13.96 5.48m0 0c.21-3.38.42-6.76.79-12.65m0 0c2.96 1.61 5.92 3.22 13.17 7.17m0 0s0 0 0 0"
            stroke="#1864ab"
            strokeWidth={1.5}
            fill="none"
          />
        </g>
      </g>
      <g strokeOpacity={0.6} fillOpacity={0.6} strokeLinecap="round">
        <path
          d="m1726.812 675.615 301.87 2.11 2.37 164.81-304.25 6.93"
          strokeWidth={0}
          fill="#e7f5ff"
        />
        <path
          d="M1732.132 676.975c92.12 3.87 188.94 3.16 299.65 1.58m-.14 1.01c.46 55.64 1.88 110.65.97 163.7m.93 3.11c-67.31-.34-134.65-5.49-300.19-1.3m-5.25-1.79c1.98-30.74.51-66.82-.29-167.16"
          stroke="#1864ab"
          strokeWidth={1.5}
          fill="none"
          strokeDasharray="8 9"
        />
      </g>
      <g strokeOpacity={0.6} fillOpacity={0.6}>
        <text
          y={35.5}
          fontFamily="Cascadia, Segoe UI Emoji"
          fill="#1864ab"
          style={{
            whiteSpace: 'pre',
          }}
          transform="translate(1773.251 717.132)"
        >
          {'GET '}
        </text>
        <text
          y={79}
          fontFamily="Cascadia, Segoe UI Emoji"
          fill="#1864ab"
          style={{
            whiteSpace: 'pre',
          }}
          transform="translate(1773.251 717.132)"
        >
          {'/index.css'}
        </text>
      </g>
      <g strokeLinecap="round">
        <g transform="translate(10 10) rotate(0 6.851691502692347 0)">
          <path
            d="M 970.6 655.157 h 13.7 m -13.7 0 h 14.4"
            stroke="#1864ab"
            strokeWidth="4"
            fill="none"
          ></path>
        </g>
      </g>
      <text
        y={35}
        fontFamily="Cascadia, Segoe UI Emoji"
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(841.751 641.93)"
      >
        {'700ms'}
      </text>

      <g strokeLinecap="round">
        <g transform="translate(10 10) rotate(0 6.851691502692347 0)">
          <path
            d="M 970.6 1025.157 h 13.7 m -13.7 0 h 14.4"
            stroke="#1864ab"
            strokeWidth="4"
            fill="none"
          ></path>
        </g>
      </g>

      <text
        y={35}
        fontFamily="Cascadia, Segoe UI Emoji"
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(840.846 1012.394)"
      >
        {'1000ms'}
      </text>
    </g>
  );
};

const SvgComponent = ({height = undefined, width, earlyHintsEnabled, ...props}) => {
  const {width: windowWidth} = useWindowSize();
  const [isMobile, setIsMobile] = useState<boolean>(false);
  useEffect(() => {
    if (windowWidth >= 768) {
      return;
    }
    setIsMobile(true);
  }, [windowWidth]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={!isMobile ? '0 0 3231.556 1782.551' : '550 0 2231.556 1782.551'}
      width={width}
      height={height}
      {...props}
      fontSize={!isMobile ? 36 : 40}
    >
      <defs>
        <style>
          {
            '@font-face{font-family:"Virgil";src:url(https://excalidraw.com/Virgil.woff2)}@font-face{font-family:"Cascadia";src:url(https://excalidraw.com/Cascadia.woff2)}'
          }
        </style>
      </defs>
      <Timeline />
      <motion.g animate={{y: earlyHintsEnabled ? 0 : -300}} transition={{delayChildren: 0.3}}>
        <ServerResponseHTML />
        <motion.g
          animate={{opacity: earlyHintsEnabled ? 0 : 1, y: 50}}
          className="preload-meta-animated"
        >
          <PreloadMetaRequests />
        </motion.g>
      </motion.g>

      <motion.g animate={{opacity: earlyHintsEnabled ? 1 : 0}} className="http-103-animated">
        <EarlyHintResponse />
      </motion.g>
      <motion.g animate={{y: earlyHintsEnabled ? 0 : 0}} transition={{delay: 0.3}}>
        <RenderedPage />
      </motion.g>
    </svg>
  );
};

const EarlyHints = () => {
  const [earlyHintsEnabled, setEarlyHintsEnabled] = useState<boolean>(true);
  const buttonRef = useRef<HTMLDivElement>(null);
  const isVisible = useIsVisible(buttonRef, {once: true});
  return (
    <div className="flex flex-col items-center">
      <SvgComponent width={'100%'} earlyHintsEnabled={earlyHintsEnabled} />
      <div className="mt-4 flex w-full max-w-md flex-col-reverse items-center justify-between gap-4 text-sm text-slate-500 md:flex-row">
        <div
          ref={buttonRef}
          className={cx('flex cursor-pointer items-center gap-1', {
            'motion-safe:animate-vibrate': isVisible,
          })}
          onClick={() => setEarlyHintsEnabled(!earlyHintsEnabled)}
        >
          <Switch
            checked={earlyHintsEnabled}
            onChange={() => {}}
            className={`${
              earlyHintsEnabled ? 'bg-blue-600' : 'bg-gray-200'
            } relative inline-flex h-4 w-8 items-center rounded-full`}
          >
            <span className="sr-only">Enable notifications</span>
            <span
              className={`${
                earlyHintsEnabled ? 'translate-x-4' : 'translate-x-1'
              } inline-block h-3 w-3 transform rounded-full bg-white`}
            />
          </Switch>
          {earlyHintsEnabled ? 'with Early Hints' : 'without Early Hints'}
        </div>
        <span>
          Largest Contentful Paint:{' '}
          {earlyHintsEnabled ? (
            <span className="ml-1 text-green-500">1.5 secs</span>
          ) : (
            <span className="ml-1 text-yellow-400">1.8 secs</span>
          )}
        </span>
      </div>
    </div>
  );
};

export default EarlyHints;
